export const CELL_DEFAULT_WIDTH = 130;
